import { useState } from "react";
import { siteConfig } from "../config/siteConfig";
import BookingModal from "./BookingModal";
import RoomDetailModal from "./RoomDetailModal";
import { ArrowUpRight, Expand } from "lucide-react";

export default function Rooms() {
  const [booking, setBooking] = useState(false);
  const [active, setActive] = useState(null);

  return (
    <section
      id="rooms"
      data-testid="rooms-section"
      className="section relative bg-[#F3EFE6]"
    >
      {/* Top heritage strip */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C5A059]/40 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal">
          <p className="font-overline mb-4">Accommodation</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] mb-4">
            Rooms
          </h2>
          <div className="gold-divider"></div>
          <p className="text-[#2C2C2C] max-w-2xl mx-auto mt-6 text-base sm:text-lg">
            Each room is a quiet retreat thoughtfully designed, warmly
            appointed. Click any room to explore.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {siteConfig.rooms.map((room, idx) => (
            <article
              key={room.id}
              data-testid={`room-card-${room.id}`}
              onClick={() => setActive(room)}
              className="reveal group relative bg-[#FAF9F6] rounded-3xl overflow-hidden hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 cursor-pointer"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="relative overflow-hidden aspect-[4/3] rounded-3xl">
                <img
                  src={room.images?.[0]}
                  alt={room.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="absolute top-4 left-4 bg-[#1A362D]/95 text-[#C5A059] px-4 py-1.5 rounded-full text-[10px] tracking-[0.22em] uppercase backdrop-blur">
                  {room.priceNote}
                </div>

                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#FAF9F6]/90 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <Expand className="w-4 h-4 text-[#1A362D]" strokeWidth={1.5} />
                </div>

                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between text-[#FAF9F6] opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0 transition-all duration-500">
                  <span className="text-xs uppercase tracking-[0.22em]">
                    {room.images?.length || 0} photos
                  </span>
                  <span className="text-xs uppercase tracking-[0.22em]">
                    View details →
                  </span>
                </div>
              </div>

              <div className="p-7 sm:p-9">
                <div className="flex items-baseline justify-between mb-2">
                  <h3 className="font-display text-2xl sm:text-3xl text-[#1A362D]">
                    {room.name}
                  </h3>
                  <span className="text-xs uppercase tracking-[0.2em] text-[#C5A059]">
                    {room.size}
                  </span>
                </div>
                <p className="text-[#2C2C2C] leading-relaxed mb-5 line-clamp-2">
                  {room.shortDescription}
                </p>
                <ul className="flex flex-wrap gap-2 mb-7">
                  {room.facilities.slice(0, 5).map((f) => (
                    <li key={f} className="chip text-[10px] !py-1 !px-3">
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="flex items-center justify-between border-t border-[#EBE5D9] pt-5">
                  <p className="text-xs uppercase tracking-widest text-[#5C4033]">
                    Check via WhatsApp
                  </p>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setBooking(true);
                    }}
                    className="inline-flex items-center gap-2 text-[#1A362D] hover:text-[#C5A059] text-xs uppercase tracking-[0.22em] font-medium"
                    data-testid={`room-inquiry-btn-${room.id}`}
                  >
                    Inquire <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <BookingModal open={booking} onOpenChange={setBooking} />
      <RoomDetailModal
        room={active}
        open={!!active}
        onOpenChange={(o) => !o && setActive(null)}
        onBookNow={() => {
          setActive(null);
          setTimeout(() => setBooking(true), 220);
        }}
      />
    </section>
  );
}
